import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/safe-stock/";

export function getSafeStock(warehouseID = 0, outletID = 0) {
  return http.get(apiEndpoint + `${warehouseID}/${outletID}`);
}

export function getSafeStockItemDetail(safeStockID = 0) {
  return http.get(apiEndpoint + `item-detail/${safeStockID}`);
}

export function saveSafeStock(safeStock) {
  return http.post(apiEndpoint, safeStock);
}

export function saveSafeStockItemDetail(safeStock) {
  return http.post(apiEndpoint + "item-detail", safeStock);
}
